import React, { Component } from "react";
import { Fstyr } from "../../components/FstyrComponents/Fstyr.js";
import { fetchModel } from "../../components/HelperComponents/FetchExtension";
import { DateFormatter } from "../../components/HelperComponents/DateFormatter.ts";
import { GetStatusName } from "../../components/HelperComponents/StatusHelper";
import { formatAuthorizationNumber, sortCardTableByDate } from "../../components/HelperComponents/Helpers";
import { WorkshopCardVm } from "../../Models/WorkshopCardVm";
import { BusinessVm } from "../../Models/BusinessVm";
import URL from "../../Constants/URL.js";
import { ValidationType } from "../../Constants/ValidationTypes.ts";
import { formatAddress } from "../../components/HelperComponents/AddressFormatter.js";

export class SearchWorkShopCVR extends Component {
  static displayName = SearchWorkShopCVR.name;

  constructor(props) {
    super(props);
    this.toast = React.createRef();

    this.state = {
      cvrInput: "",

      showSpinner: false,
      businessVm: [new BusinessVm()],
      workshopCards: [],

      //Button press
      searchButtonPressed: false,

      //Validation
      cvrInputIsValid: false,
    };
  }

  fetchWorkshopCards() {
    fetchModel("GET", URL + "/api/WorkshopCard/GetWorkshopCardsWithCvr", this.state.cvrInput, WorkshopCardVm)
      .then((model) => {
        this.handleWorkshopSearchResults(model);
        this.setState({ showSpinner: false });
      })
      .catch((error) => {
        this.showErrorToast(error, "et værkstedskort");
        this.setState({ showSpinner: false });
      });
  }

  fetchBusinessVm() {
    fetchModel("GET", URL + "/api/search/GetVirksomhed", this.state.cvrInput, BusinessVm)
      .then((model) => {
        this.setState({ businessVm: model });
        this.setState({ showSpinner: false });
      })
      .catch((error) => {
        this.showErrorToast(error, "et værksted");
        this.setState({ showSpinner: false });
      });
  }

  fetchSearchResults() {
    this.setState({ searchButtonPressed: true });
    if (this.state.cvrInputIsValid) {
      this.clearPage(false);
      this.setState({ showSpinner: true });
      this.fetchBusinessVm();
      this.fetchWorkshopCards();
    }
  }

  handleWorkshopSearchResults(result) {
    let results = [];
    result = sortCardTableByDate(result);
    for (let i = 0; i < result.length; i++) {
      results.push([result[i].CardNumber, result[i].Cvr, formatAuthorizationNumber(result[i].AuthorizationNumber), result[i].Person.FirstName, result[i].Person.LastName, DateFormatter(result[i].ValidFrom), DateFormatter(result[i].ValidTo), GetStatusName(result[i].Status.Id)]);
    }

    this.setState({
      workshopCards: results,
    });
  }

  clearPage(clearInput) {
    this.setState({
      showSpinner: false,
      businessVm: [new BusinessVm()],
      workshopCards: [],
    });
    if (clearInput) {
      this.setState({
        cvrInput: "",
        cvrInputIsValid: false,
        searchButtonPressed: false,
      });
    }
  }

  showErrorToast(error, message) {
    this.setState({ showSpinner: false });
    if (error === "No result") {
      this.toast.current.show("Værkstedskort", "Der findes ikke " + message + " med det søgte CVR", "warning");
    } else if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke forbinde til databasen", "error");
    } else {
      this.toast.current.show("Fejl", "Der skete en fejl: " + error, "error");
    }
  }

  render() {
    return (
      <div>
        <Fstyr.Toast ref={this.toast} />
        <Fstyr.Segment title="Søg Værkstedskort" isPageTitle={true}>
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => {
                this.clearPage(true);
              }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment title="Angiv CVR">
          <Fstyr.Input
            value={this.state.cvrInput}
            label="CVR nummer"
            onChange={(value) => this.setState({ cvrInput: value })}
            type={"number"}
            validation={true}
            validationType={ValidationType.cvr}
            errorBodyText={"Skal være 8 cifre langt"}
            errorExampleText={"F.eks. 12345678"}
            onEnterPressed={() => this.fetchSearchResults()}
            setValid={(valid) => this.setState({ cvrInputIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
          />

          <div className="fstyr-left-button-group">
            <Fstyr.Button label="Søg" onClick={() => this.fetchSearchResults()} disabled={this.state.showSpinner} />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner show={this.state.showSpinner} />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment title="Værkstedsinformation">
          <div>
            <div className="fstyr-attention-box">
              <p>Værkstedsoplysninger</p>
              <Fstyr.Input label="CVR" readonly={true} value={this.state.businessVm[0].Cvr === "0" ? "" : this.state.businessVm[0].Cvr} direction="row" />
              <Fstyr.Input label="Værkstedsnavn" readonly={true} value={this.state.businessVm[0].Name} direction="row" />
              <Fstyr.Input label="CVR Adresse" readonly={true} value={formatAddress(this.state.businessVm[0].Address, true)} direction="row" />
            </div>
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment title="Registreret værkstedskort">
          <Fstyr.SelectableTable headers={["Kortnr.", "CVR", "Autorisationsnummer", "Fornavn", "Efternavn", "Startdato", "Udløbsdato", "Status"]} data={this.state.workshopCards} note={"Virksomhed har " + this.state.workshopCards.length + " registreringer på værkstedskort"} path={"workshopCard"} disableAll={true} useLinks={true} />
        </Fstyr.Segment>
      </div>
    );
  }
}
